<template>
  <svg
    id="cross-small"
    viewBox="0 0 12 12"
  >
    <path
      d="M11.1783 1.17833L10 0L5.58917 4.41083L1.17833 0L0 1.17833L4.41083 5.58917L0 10L1.17833 11.1783L5.58917 6.7675L10 11.1783L11.1783 10L6.7675 5.58917L11.1783 1.17833Z"
    />
  </svg>
</template>